export enum MaterialStatus {
    Unacquired = 0,
    Ordered = 1,
    Procured = 2,
}

